import { ReportSettingsReportKey } from "@common/types/reports/report-settings-report-key";

export const REPORT_SETTING_SOURCE_KINDS = [
    "entity-override",
    "entity-template",
    "workspace-override",
    "workspace-template",
    "firm-default-template",
    "template",
    "kick-default",
] as const;

export type ReportSettingSourceKind =
    (typeof REPORT_SETTING_SOURCE_KINDS)[number];

export interface ReportSettingSource {
    kind: ReportSettingSourceKind;
    reportKey: ReportSettingsReportKey;
    templateId?: string;
    templateName?: string;
    organizationId?: string;
}
